import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';

async function deleteContacts(
  auth: Authentication,
  apiKey: string,
  contactIds: string[]
): Promise<any> {
  try {
    return await HttpClient.delete(
      '/contacts',
      {
        contactIds,
      },
      auth.token,
      {
        'x-api-key': apiKey
      }
    );
  } catch (e) {
    console.log('error: ', e);
    throw new DeleteContactsFailure((e as Error)?.message);
  }
}

export class DeleteContactsFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default deleteContacts;
